module.exports = __webpack_public_path__ + "static/media/d4.87aabc4a.png";